import { styled } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'

export const ArticlePageRoot = styled('div')(({ theme }) => ({
  padding: theme.spacing(0),
  backgroundColor: 'white',
  overflow: 'hidden',
  '& .archive-content img': {
    maxWidth: '100%',
  },
}))

export const ArchiveContent = styled('div')(() => ({
  '& img': {
    maxWidth: '100%',
  },
}))

export const PageTop = styled('div')(() => ({
  textAlign: 'center',
}))

export const Kicker = styled('div')(({ theme }) => ({
  padding: theme.spacing(2, 0),
}))

export const StoryGrid = styled(Grid)(({ theme }) => ({
  padding: '0 4rem',
  [theme.breakpoints.down('sm')]: {
    padding: '0 1.5rem',
  },
}))
